export const INPUT_SPREAD_HALF = 'INPUT_SPREAD_HALF'
export const INPUT_SPREAD_FULL = 'INPUT_SPREAD_FULL'
